import * as actionTypes from '../actions/actionTypes';
import { updateObject } from '../utility';

const initialState = {
    error: null,
    loading: false,
    //users: [],
    users: [
    ],
    institutions: [
    ]
};

const reducer = ( state = initialState, action) => {
    switch (action.type) {
        case actionTypes.CRM_GET_USER_START:
            return updateObject(state, { loading: true });
        case actionTypes.CRM_GET_USER_FAIL:
            return updateObject(state, { loading: false });
        case actionTypes.CRM_GET_USER_SUCCESS:
            return updateObject(state, { loading: false, person: action.person });
        case actionTypes.CRM_SEARCH_USERS_START:
            return updateObject(state, { loading: true });
        case actionTypes.CRM_SEARCH_USERS_FAIL:
            return updateObject(state, { loading: false });
        case actionTypes.CRM_SEARCH_USERS_SUCCESS:
            return updateObject(state, { loading: false, persons: action.persons });
        case actionTypes.CRM_SEARCH_INST_START:
            return updateObject(state, { loading: true });
        case actionTypes.CRM_SEARCH_INST_FAIL:
            return updateObject(state, { loading: false });
        case actionTypes.CRM_SEARCH_INST_SUCCESS:
            return updateObject(state, { loading: false, institutions: action.insts });					
        case actionTypes.CRM_ALL_INST_SUCCESS:
            return updateObject(state, { loading: false, allinstitutions: action.allinsts });					
        case actionTypes.CRM_SEARCH_GROUP_START:
            return updateObject(state, { loading: true });
        case actionTypes.CRM_SEARCH_GROUP_FAIL:
            return updateObject(state, { loading: false });
        case actionTypes.CRM_SEARCH_GROUP_SUCCESS:
            return updateObject(state, { loading: false, groups: action.groups });
        case actionTypes.CRM_CREATE_GROUP_START:
            return updateObject(state, { loading: true });
        case actionTypes.CRM_CREATE_GROUP_FAIL:
            return updateObject(state, { loading: false });
        case actionTypes.CRM_CREATE_GROUP_SUCCESS:
            return updateObject(state, { loading: false, groups: action.groups });
        case actionTypes.CRM_DELETE_GROUP_START:
            return updateObject(state, { loading: true });
        case actionTypes.CRM_DELETE_GROUP_FAIL:
            return updateObject(state, { loading: false });
        case actionTypes.CRM_DELETE_GROUP_SUCCESS:
            return updateObject(state, { loading: false, groups: action.groups });
        case actionTypes.CRM_GET_GROUP_START:
            return updateObject(state, { loading: true });
        case actionTypes.CRM_GET_GROUP_FAIL:
            return updateObject(state, { loading: false });
        case actionTypes.CRM_GET_GROUP_SUCCESS:
            return updateObject(state, { loading: false, group: action.group });
        case actionTypes.CRM_SAVE_GROUP_START:
            return updateObject(state, { loading: true });
        case actionTypes.CRM_SAVE_GROUP_FAIL:
            return updateObject(state, { loading: false });
        case actionTypes.CRM_SAVE_GROUP_SUCCESS:
            return updateObject(state, { loading: false, groups: action.groups });
        case actionTypes.CRM_ADDTO_GROUP_START:
            return updateObject(state, { loading: true });
        case actionTypes.CRM_ADDTO_GROUP_FAIL:
            return updateObject(state, { loading: false });
        case actionTypes.CRM_ADDTO_GROUP_SUCCESS:
            return updateObject(state, { loading: false, group: action.group });
        case actionTypes.CRM_REMOVEFROM_GROUP_START:
            return updateObject(state, { loading: true });
        case actionTypes.CRM_REMOVEFROM_GROUP_FAIL:
            return updateObject(state, { loading: false });
        case actionTypes.CRM_REMOVEFROM_GROUP_SUCCESS:
            return updateObject(state, { loading: false, group: action.group });
        default: 
            return state;
    }
}

export default reducer;
